import { render, staticRenderFns } from "./BrandAvatar.vue?vue&type=template&id=5683f2ca"
import script from "./BrandAvatar.vue?vue&type=script&lang=js"
export * from "./BrandAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports